import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import {
  StaffQueryParams,
  StaffPaginatedResponse,
  StaffUpdatePayload,
  CreateStaffPayload,
} from '@app/utils/interfaces/staff.interface';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getFilledParams } from '@app/utils/helpers/request.helpers';
import { PersonalInformationResponse } from '@app/utils/interfaces/onboardingSlide.interface';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public getStaff(params?: StaffQueryParams): Observable<StaffPaginatedResponse> {
    return this.http.get<StaffPaginatedResponse>(`${this.baseUrl}${ApiEndpoints.GET_USER}`, {
      params: getFilledParams(params),
    });
  }

  public getPersonalInformation(): Observable<PersonalInformationResponse> {
    return this.http.get<PersonalInformationResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_PERSONAL_INFORMATION}`,
    );
  }

  public updateStaffPersonalInfo(id: string, payload: StaffUpdatePayload): Observable<void> {
    return this.http
      .patch<void>(`${this.baseUrl}${ApiEndpoints.GET_USER}/${id}`, payload)
      .pipe(map(() => void 0));
  }

  public createStaff(payload: CreateStaffPayload): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.GET_USER}`, payload);
  }

  public removeStaff(id: string): Observable<void> {
    return this.http
      .delete<void>(`${this.baseUrl}${ApiEndpoints.GET_USER}/${id}`)
      .pipe(map(() => void 0));
  }

  public resetStaffPassword(id: string): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}${ApiEndpoints.GET_USER}/${id}/reset-password`,
      null,
    );
  }
}
